import {Line , Doughnut} from 'react-chartjs-2'
import {Button, ProgressBar} from "react-bootstrap";
import {IconButton} from "@mui/material";
import {ChevronRight} from "@mui/icons-material";
import React from "react";
import {useMediaQuery} from "@material-ui/core";

export  function WeekPerWeekLineGraph(){
    const labels =['Week 5' , 'Week 4' , 'Week 3' , 'Week 2' , 'Last Week' , 'This Week'];
    const dataChart1=[50 , 30 ,40 , 60 , 70 ,10];
    const dataChart2=[120 , 70 ,60 , 40 , 30 ,50];
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl= useMediaQuery('(min-width:1200px)');
    let height = 0;
    // if(lg){
    //     height ='180px'
    // }else{
    //     height ='300px'
    // }
    return(
        <Line
            height={350}
            data={{
                labels : labels,
                datasets :[{
                    data : dataChart1,
                    label: 'Juste',
                    // hoverBorderColor : 'rgba(0, 0, 0, 0.12)',
                    borderColor: 'green',
                    hoverBorderWidth : 2
                }, {
                    data : dataChart2,
                    label: 'Faux',
                    // hoverBorderColor : 'rgba(0, 0, 0, 0.12)',
                    borderColor: 'orange',
                    hoverBorderWidth : 2
                }],
            }}
            options={{
                maintainAspectRatio: false ,
                // responsive:false,
                plugins: {
                    title: {
                        display: true,
                        text: 'Votre performance semaine par semaine',
                        color : 'gray',
                        padding: {
                            top: 10,
                            bottom: 30
                        }
                    }
                }
            }}

            />
    )
}

export function AnswersDoughnutChart(){
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl= useMediaQuery('(min-width:1200px)');
    const labels =['Correcte' , 'Incorrect' , 'Skipped'];
    const dataChart=[60 , 20 ,5];
    return (
        <Doughnut
            height={350}
            data={{
                labels : labels,
                datasets :[{
                    data : dataChart,
                    backgroundColor: [
                        'green',
                        'orange',
                        'gray',
                    ],
                    hoverOffset: 4,
                }],
            }}
            options={{
                maintainAspectRatio: false ,
                plugins: {
                    title: {
                        display: true,
                        text: 'Votre performance semaine par semaine',
                        color : 'gray',
                        padding: {
                            top: 10,
                            bottom: 30
                        }
                    }
                }
            }}

        />
    )
}

export function ProgressionLineChart(){
    const labels =['17/09' , '18/09' , '19/09' , '20/09' , '21/09' , '22/09'];
    const dataChart1=[120 , 140 ,90 , 80 , 120 ,100];
    const dataChart2=[80 , 90 ,85 , 35 , 90 ,80];
    return (
        <Line
            height={350}
            data={{
                labels : labels,
                datasets :[{
                    data : dataChart1,
                    label: 'Attempted',
                    // hoverBorderColor : 'rgba(0, 0, 0, 0.12)',
                    borderColor: 'cyan',
                    hoverBorderWidth : 2
                }, {
                    data : dataChart2,
                    label: 'Correct',
                    // hoverBorderColor : 'rgba(0, 0, 0, 0.12)',
                    borderColor: 'green',
                    hoverBorderWidth : 2
                }],
            }}
            options={{
                maintainAspectRatio: false ,
                plugins: {
                    title: {
                        display: true,
                        text: 'Votre Progression',
                        color : 'gray',
                        padding: {
                            top: 10,
                            bottom: 30
                        }
                    }
                }
            }}

        />
    )
}

export function ModuleProgress(){
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl= useMediaQuery('(min-width:1200px)');
    return (
        <div className="col-12">
            <div className="profile card card-body p-3">
                <div className="btn mt-2 mb-2 border border-info rounded"  variant="outline-light btn-square justify-content-lg-between">
                    <div className="w-100 d-flex">
                        <div className="d-flex">
                            <div className="d-flex justify-content-center align-items-center  mr-2" style={{border : '2px solid #eee' , borderRadius : '100%' , width :  lg ? '80px' : '60px' , height : '50px' , fontSize : '1rem'}}> <span>41%</span> </div>
                            <div className="d-flex flex-column pr-3 pl-3">
                                <div >Dermatologie</div>
                                <div style={{fontSize : '0.7rem'}}>Vous avez répondu sur 143 questions</div>
                            </div>
                        </div>
                        {
                            lg ? (
                                <div className="w-100 align-self-center">
                                    <ProgressBar className="modulesProgressBars" style={{height : '1.8rem'}}>
                                        <ProgressBar className="modulesProgressBars"  variant="success" now={35} key={1} />
                                        <ProgressBar className="modulesProgressBars" variant="danger" now={20} key={2} />
                                    </ProgressBar>
                                </div>
                            ):null
                        }

                        <div className="pl-2">
                            <IconButton aria-label="delete" size="large">
                                <ChevronRight style={{  fontSize : '2rem'}} />
                            </IconButton>
                        </div>
                    </div>
                    {
                        !lg ? (
                            <div className="w-100 align-self-center px-2 py-2">
                                <ProgressBar className="modulesProgressBars" style={{height : '1.8rem'}}>
                                    <ProgressBar className="modulesProgressBars"  variant="success" now={35} key={1} />
                                    <ProgressBar className="modulesProgressBars" variant="danger" now={20} key={2} />
                                </ProgressBar>
                            </div>
                        ) :  null
                    }

                </div>
            </div>
        </div>



    )

}


